// @ts-ignore
import React from "react";
import { modalStore } from "library/core/stores/modal";
import AccountSuspendedModal from "./AccountSuspendedModal";

export { default } from "./AccountSuspendedModal";

export const openAccountSuspendedModal = () => {
  modalStore.toggleModal(
    <AccountSuspendedModal isOpen={true} />,
    true,
    "primary",
    {
      scrollTop: true,
      showNativeCloseButton: false,
    }
  );
};
